import React, { useState, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Spinner from "../layout/Spinner";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getASSAAssetsAndLiabilityReport,
  getExcessPayData,
  getAssaSurplusAndDeficit,
  getBatchTranDetails,
  getMeetingTransactionData,
  batchAndMeetingDetails
} from "../../actions/shg";
import { CSVLink } from "react-csv";
import { calculateCashInHandForBatch, getOtherLoanOverPaidDetails } from "./TallyFunctions";
const AssetLiabilityTallyReport = ({
  auth: { isAuthenticated, user, users },
  shg: {
    loadStatus,
    ASSAAssetAndLiability,
    surplusDeficit,
    batchTranDetails
  },
  getASSAAssetsAndLiabilityReport,
  getExcessPayData,
  getAssaSurplusAndDeficit,
  getBatchTranDetails,
  batchAndMeetingDetails,
  getMeetingTransactionData
}) => {


  useEffect(() => {
    getASSAAssetsAndLiabilityReport();
    getExcessPayData();
    getAssaSurplusAndDeficit();

  }, [getASSAAssetsAndLiabilityReport]);

  useEffect(() => {
    if (ASSAAssetAndLiability) {
      getBatchTranDetails({ batchId: ASSAAssetAndLiability._id })
    }
  }, [ASSAAssetAndLiability])

  let fiscalyearstart = "",
    fiscalyearend = "";
  let today = new Date();

  if (today.getMonth() + 1 <= 3) {
    // fiscalyearstart = today.getFullYear() - 1 + "-04-01";
    const fullyear = today.getFullYear() - 1;
    fiscalyearend = "31-03-" + fullyear;
  } else {
    // fiscalyearstart = today.getFullYear() + "-04-01";
    // fiscalyearend = today.getFullYear() + 1 + "-03-31";
    const fullyear = today.getFullYear() + 1;
    fiscalyearend = "31-03-" + fullyear;
  }

  const toSelectedDate = fiscalyearend;


  ////////////////Liability/////////////////
  const getAllOthLoan = (data) => {

    const getAllothLoanData=Number(data.otherLoanSanctionedToShg) - Number(data.otherLoanPaidToDonor)
    return Math.round(getAllothLoanData * 100) / 100
  
  };

  const getMemSvgAmt = (data) => {
    const getMemSvgAmtdata=Number(data.batchSavingAmt) - Number(data.batchSavingWithdrawals);
   return Math.round(getMemSvgAmtdata * 100) / 100
  };

  const getSDMem = (data) => {
    const getSDMemdata=
      Number(data.batchSecurityDepositMemToShg) -
      Number(data.batchSecurityDeposit)
      return Math.round(getSDMemdata * 100) / 100
    
  };
  ////////////////LiabilityTotal////////////////////
  const liabilityTotal = (liabilityTotal) => {
    const liabilityData =
      getAllOthLoan(liabilityTotal) +
      getMemSvgAmt(liabilityTotal) +
      getSDMem(liabilityTotal) +
      Number((surplusDeficit && surplusDeficit.surplus) || 0) -
      Number(Math.abs(surplusDeficit && surplusDeficit.deficit))

    return Math.round(liabilityData * 100) / 100


  };
  //////////////Assets///////////////////

  const getBankBalance = (data) => {
    const BankBalancedata=
      Number(data.sumOfDeposit) +
      Number(data.sumOfInt) -
      Number(data.sumOfWithdr) -
      Number(data.sumOfComm)
    return  Math.round(BankBalancedata * 100) / 100
  };

  const getIL = (data) => {
    const getIldata= Number(data.batchLoanAmt) - Number(data.batchLoanPaid);
      return  Math.round(getIldata * 100) / 100
  };

  const getOLPaid = (data) => {
    if (Number(data.otherLoanSanctionedToMember) - Number(data.otherLoanPaidToShg) < 0) {
      return 0
    } else {
const getolpaidData=Number(data.otherLoanSanctionedToMember) - Number(data.otherLoanPaidToShg)
       return  Math.round(getolpaidData * 100) / 100
    }
  };

  const getSD = (data) => {
    const getSDdata= Number(data.sdUnionToSHG) - Number(data.sdSHGToUnion);
     return  Math.round(getSDdata * 100) / 100
  };
  //////////////AssetsTotal/////////////////
  const assetTotal = (assetTotal) => {
    const assetData =
      getBankBalance(assetTotal) +
      Number(assetTotal.cashInHand) +
      // Number((excessPayment && excessPayment.excessPayment) || 0) +
      getIL(assetTotal) +
      getOLPaid(assetTotal) +
      getSD(assetTotal)
    // +
    // Number((surplusDeficit && surplusDeficit.deficit) || 0)

    return Math.round(assetData * 100) / 100


  };
  /////////////////////Excel Report//////////////
  const csvData = [
    [
      //asset
      "Bank Balance",
      "Cash Balance",
      "Internal Loan",
      "OL Paid / Received From Members",
      "SHG Security Deposit",

      //Liability
      "All Other Loans",
      "Members Savings Amount",
      "Security Deposit Members",
      "Deficit",
      "Surplus",
    ],
  ];
  if (ASSAAssetAndLiability)
    csvData.push([
      //assets
      getBankBalance(ASSAAssetAndLiability),
      ASSAAssetAndLiability.cashInHand,
      getIL(ASSAAssetAndLiability),
      getOLPaid(ASSAAssetAndLiability),
      getSD(ASSAAssetAndLiability),

      //liability
      getAllOthLoan(ASSAAssetAndLiability),
      getMemSvgAmt(ASSAAssetAndLiability),
      getSDMem(ASSAAssetAndLiability),
      Number(surplusDeficit && surplusDeficit.deficit),
      Number(surplusDeficit && surplusDeficit.surplus),
    ]);

  const income_expense_total_per_meeting = batchTranDetails && calculateCashInHandForBatch(batchTranDetails);
  const getOtherLoanOverPaid = batchTranDetails && getOtherLoanOverPaidDetails(batchTranDetails);
  // const filteredCashInHandIssues = income_expense_total_per_meeting && income_expense_total_per_meeting.filter(item => item.calculatedCashInHand !== item.originalCashInHand);
  // const filteredOtherLoanOverPaidIssues = getOtherLoanOverPaid && getOtherLoanOverPaid.filter(item => item.otherLoanOverPaid > 0);
  // console.log("income_expense_total_per_meeting", batchTranDetails);
  // console.log("getOtherLoanOverPaid", getOtherLoanOverPaid);
  // console.table(getOtherLoanOverPaid);
  //------------------------------------------------------------------------



  const goToConflictedMeetingDate = (item) => {
    // localStorage.removeItem("batchTransactionData");
    const batchIdData = {
      batchId: item.batchId,
      batchTransactionType: item.batchTransactionType,
      mdDate: item.meetingDate.split("T")[0],
      mdBatchId: item.batchId,
      batchIdVal: item.batchId,
      batchName: item.batchName,
      callFrom: "Report",
    };
    // console.log("batchIdData", batchIdData);
    let meetingBatchInfo = batchIdData;
    getMeetingTransactionData(meetingBatchInfo);
    batchAndMeetingDetails(batchIdData);
  }


  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      {loadStatus ?
        (
          <Spinner />
        )
        :
        (
          <div className="container container_align ">
            <div className="col-lg-11 col-md-11 col-sm-11 col-11">
              <h2 className="heading_color">Assets & Liabilities Report</h2>
              <hr />
            </div>  {ASSAAssetAndLiability ? (

              <section className="sub_reg">

                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding">
                  <>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>State : </b> {ASSAAssetAndLiability.stateName}</label>
                      {/* <p className="assettallyReport">StateName:{ASSAAssetAndLiability.stateName}</p> */}
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>District : </b> {ASSAAssetAndLiability.districtName}</label>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>Block : </b> {ASSAAssetAndLiability.blockName}</label>
                    </div>
                    <div className="col-lg-4 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>Date : </b> {toSelectedDate}</label>

                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-4 col-11 mt-1">
                      <label className="label-control"><b>Batch : </b> {ASSAAssetAndLiability.batchName}</label>
                    </div>

                  </>
                </div>
                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding mt-2">

                  <div className="col-lg-4 col-md-8 col-sm-4 col-11 ">


                  </div>
                  <div className="col-lg-8 col-md-3 col-sm-4 col-11 py-3">


                    <Link to="/TallyReport">
                      <img
                        className="img_icon_size log float-right ml-3"
                        src={require("../../static/images/back.png")}
                        alt="Back"
                        title="Back"
                      />
                    </Link>


                    {/* <img
                className="img_icon_size log float-right ml-3"
                onClick={() => onClickReset()}
                src={require("../../static/images/refresh-icon.png")}
                alt="refresh"
                title="Refresh"
              /> */}
                    <CSVLink data={csvData}>
                      <img
                        className="img_icon_size log float-right ml-4"
                        src={require("../../static/images/ExcelIcon.png")}
                        alt="Excel-Export"
                        title="Excel-Export"
                      />
                    </CSVLink>
                  </div>
                </div>


                <div className="row col-lg-11 col-md-11 col-sm-11 col-11 "></div>
                <div className="row col-11">
                  <div className="col-lg-6 col-md-11 col-sm-11 col-11">
                    <div className=" body-inner no-padding table-responsive ">
                      <h4>
                        <center>
                          <b> ASSET</b>
                        </center>
                      </h4>
                      <table
                        className="table table-bordered table-striped table-hover"
                        id="datatable2"
                      >
                        <thead>
                          <tr>
                            <th>Asset</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            <tr>
                              <td>Bank Balance</td>
                              <td>{getBankBalance(ASSAAssetAndLiability)}</td>
                            </tr>
                            <tr>
                              <td> Cash Balance</td>
                              <td>{ASSAAssetAndLiability.cashInHand}</td>
                            </tr>
                            <tr>
                              <td>Internal Loan</td>
                              <td>{getIL(ASSAAssetAndLiability)}</td>
                            </tr>
                            <tr>
                              <td>OL Paid / Received From Members</td>
                              <td>{getOLPaid(ASSAAssetAndLiability)}</td>
                            </tr>
                            <tr>
                              <td>SHG Security Deposit</td>
                              <td>{getSD(ASSAAssetAndLiability)}</td>
                            </tr>

                            <tr>
                              <td>
                                <b>Total</b>
                              </td>
                              <td>
                                <b>{assetTotal(ASSAAssetAndLiability)}</b>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-11 col-sm-11 col-11 ">
                    <h4>
                      <center>
                        <b>LIABILITY </b>
                      </center>
                    </h4>

                    <div className=" body-inner no-padding table-responsive ">
                      <table
                        className="table table-bordered table-striped table-hover"
                        id="datatable2"
                      >
                        <thead>
                          <tr>
                            <th width="60%">Liability</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            <tr>
                              <td>All Other Loans</td>
                              <td>{getAllOthLoan(ASSAAssetAndLiability)}</td>
                            </tr>
                            <tr>
                              <td>Members Savings Amount</td>
                              <td>{getMemSvgAmt(ASSAAssetAndLiability)}</td>
                            </tr>
                            <tr>
                              <td>Security Deposit Members</td>
                              <td>{getSDMem(ASSAAssetAndLiability)}</td>
                            </tr>

                            {surplusDeficit && surplusDeficit.surplus != 0 ? (
                              <tr>
                                <td>
                                  <b>Surplus</b>
                                </td>
                                <td>
                                  {surplusDeficit && Math.round(surplusDeficit.surplus * 100) / 100}
                                </td>
                              </tr>
                            ) : (
                              <></>
                            )}
                            {surplusDeficit && surplusDeficit.deficit != 0 ? (
                              <tr>
                                <td>
                                  <b>Deficit</b>
                                </td>
                                <td>
                                  {surplusDeficit && Math.round(surplusDeficit.deficit * 100) / 100}
                                </td>
                              </tr>
                            ) : (
                              <></>
                            )}

                            <tr>
                              <td>
                                <b>Total</b>
                              </td>
                              <td>
                                <b>{liabilityTotal(ASSAAssetAndLiability)}</b>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            ) :
              (<></>)
            }


            <h4>
              <center >
                <p style={{ color: "red" }}>

                  <b>Difference amount:</b>{ASSAAssetAndLiability && (assetTotal(ASSAAssetAndLiability) - liabilityTotal(ASSAAssetAndLiability))}
                </p>

              </center>
            </h4>
            {/* error details section start */}
            <h4>
              <center>
                <b> Cash in hand issue</b>
              </center>
            </h4>
            <div className="col-lg-10 d-flex justify-content-center">
              {income_expense_total_per_meeting && income_expense_total_per_meeting.length > 0 ? (
                <table
                  id="datatable2"
                  className="table">
                  <thead>
                    <tr>
                      <th>Meeting Date</th>
                      <th>Income</th>
                      <th>Expense</th>
                      <th>Calculated Cash In Hand</th>
                      <th>Original Cash In Hand</th>

                    </tr>
                  </thead>
                  <tbody>
                    {income_expense_total_per_meeting.map((item, index) => (
                      <tr key={index}>
                        {index === 0 ?

                          <td><b>


                            <Link
                              to={{
                                pathname:
                                  item &&
                                    item.batchTransactionType ===
                                    "Memberwise"
                                    ? "/verification-batch-membermeeting"
                                    : "/verification-batchmeeting",
                              }}
                              className="btnLink"
                              onClick={() =>
                                goToConflictedMeetingDate(
                                  item
                                )
                              }
                            >
                              {item.meetingDate.split("T")[0].split("-").reverse().join("-")}
                            </Link>


                          </b></td>
                          : <td>
                            {item.meetingDate.split("T")[0].split("-").reverse().join("-")}
                          </td>}

                        <td>{item.income}</td>
                        <td>{item.expense}</td>
                        <td>{item.calculatedCashInHand}</td>
                        <td>{item.originalCashInHand}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <></>
              )}
            </div>

            {getOtherLoanOverPaid && getOtherLoanOverPaid.length > 0 && (<h4>
              <center>
                <b>Other Loan Over Paid Issue</b>
              </center>
            </h4>)}

            <div className="col-lg-10 d-flex justify-content-center">
              {getOtherLoanOverPaid && getOtherLoanOverPaid.length > 0 ? (
                <table
                  id="datatable2"
                  className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Meeting Date</th>
                      <th>Taken Amount</th>
                      <th>Paid Amount</th>
                      <th>Over Paid Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getOtherLoanOverPaid.map((item, index) => (
                      <tr key={index}>
                        {index === 0 ?

                          <td><b>


                            <Link
                              to={{
                                pathname:
                                  item &&
                                    item.batchTransactionType ===
                                    "Memberwise"
                                    ? "/verification-batch-membermeeting"
                                    : "/verification-batchmeeting",
                              }}
                              className="btnLink"
                              onClick={() =>
                                goToConflictedMeetingDate(
                                  item
                                )
                              }
                            >
                              {item.meetingDate.split("T")[0].split("-").reverse().join("-")}
                            </Link>


                          </b></td>
                          : <td>
                            {item.meetingDate.split("T")[0].split("-").reverse().join("-")}
                          </td>}




                        {/* <td>{item.date.split("T")[0].split("-").reverse().join("-")}</td> */}
                        <td>{item.totalTaken}</td>
                        <td>{item.totalPaid}</td>
                        <td>{item.overPaidAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p></p>
              )}
            </div>
          </div>
        )}

    </Fragment>
  );
};
AssetLiabilityTallyReport.prototypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  getAllBatchesDropdown: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});
export default connect(mapStateToProps, {

  getASSAAssetsAndLiabilityReport,
  getExcessPayData,
  getAssaSurplusAndDeficit,
  getBatchTranDetails,
  batchAndMeetingDetails,
  getMeetingTransactionData
})(AssetLiabilityTallyReport);
